import { Download } from "@mui/icons-material";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import DashImportacaoHeaderModel from "../../components/classes/DashImportacaoHeader";
import DashImportacaoModel from "../../components/classes/DashImportacao";
import Parceiro from "../../components/classes/Parceiro";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import SkuHelper from "../../helper/skuHelper";
import Utils from "../../helper/utils";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function DashboardImportacaoGrid(
  props: DashboardImportacaoPropsTypes
) {
  const { t } = useTranslation();

  const [rows, setRows] = useState<Data>([]);
  const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);


  const columns: GridColumns = createColumns();

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: t("common.id"),
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "parceiro",
        headerName: t("common.partner"),
        type: "string",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "bookingStatus",
        headerName: t("common.bookingStatus"),
        type: "string",
        width: 180,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "sequenciaInstrucaoEmbarque",
        headerName: t("pages.dashboardImport.text.seqNoBoardingInstruction"),
        type: "string",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "sequenciaDoEmbarque",
        headerName: t("pages.dashboardImport.text.boardingSequenceNumber"),
        type: "string",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "documentoCompra",
        headerName: t("common.purchasingDocument"),
        type: "string",
        width: 160,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "item",
        headerName: t("common.item"),
        type: "number",
        width: 100,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "idSku",
        headerName: t("common.sku"),
        type: "string",
        width: 110,
        headerAlign: "center",
        align: "center",
        editable: false,
      },
      {
        field: "skuDescricao",
        headerName: t("common.description"),
        type: "string",
        width: 340,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => <p>{SkuHelper.getSKUName(item.value)}</p>,
      },
      {
        field: "quantidadePedido",
        headerName: t("common.orderQuantity"),
        type: "number",
        width: 120,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return (
            <p>
              {Utils.maskNumberToSAPDecimalVisualization(item.value.toString())}
            </p>
          );
        },
      },
      {
        field: "quantidadeEmbarque",
        headerName: t("common.shipmentQuantity"),
        type: "number",
        width: 130,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return (
            <p>
              {Utils.maskNumberToSAPDecimalVisualization(item.value.toString())}
            </p>
          );
        },
      },
      {
        field: "dataRemessaEstatistica",
        headerName: t("common.staticShippingDate"),
        type: "dateTime",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
      {
        field: "dataRemessa",
        headerName: t("common.shipmentDate"),
        type: "dateTime",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
      {
        field: "previsaoEntradaEstoque",
        headerName: t("common.stockEntryForecast"),
        type: "date",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
      {
        field: "entradaEstoque",
        headerName: t("common.entryIntoStock"),
        type: "date",
        width: 200,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
    ];
    return cols;
  }

  const fillTable = () => {
    let gridData: Data = [];
    props.dashImportacaoArr?.data.forEach(
      (item: DashImportacaoModel, index: number) => {
        let json = JSON.parse(DashImportacaoModel.toJson(item));
        json.id = index;
        gridData.push(json);
      }
    );
    setRows(gridData);
  }

  useEffect(() => {
    if (props.dashImportacaoArr) {
      fillTable();
    }
  }, [props]);

  function montaNomeFornecedor(codigoFornecedorSap: number): string {
    const parceiroSelecionadoCache: string = String(
      localStorage.getItem("ParceiroSelecionado")
    );
    if (parceiroSelecionadoCache && parceiroSelecionadoCache !== "undefined") {
      const parceiro: Parceiro = JSON.parse(parceiroSelecionadoCache);
      if (parceiro) {
        return String(parceiro.nome);
      }
    }
    return "";
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  return (
    <div style={{ height: "60vh", width: "100%" }}>
      <div className="containerToolbar">
        <Tooltip title={t("pages.dashboardImport.text.csvDownload")}>
          <span>
            <IconButton onClick={handleClickOpenDownloadCSV}>
              <Download />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        rowsPerPageOptions={[50, 100, 250, 500]}
      />
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={rows}
          columns={columns}
          name={t("pages.dashboardImport.pageTitle")}
        />
      </Modal>
    </div>
  );
}

interface DashboardImportacaoPropsTypes {
  dashImportacaoArr?: DashImportacaoHeaderModel;
}
